import { CreditCardIcon, EmotionBreakpoint } from 'dw-au-react-components';

import PropTypes from 'prop-types';
import React from 'react';
import styled from '@emotion/styled';

const StyledCardIconGroup = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	.card-group {
		display: flex;
		> div:not(:last-child) {
			padding-right: 18px;
			${EmotionBreakpoint('mobile')} {
				padding-right: 25px;
			}
		}
	}
`;
const CreditCardIconGroup = ({ activeCard, validCards }) => {
	const renderCardIcons = () =>
		validCards.map((card, index) => {
			const isActive = activeCard === 'All' || activeCard === card;
			return <CreditCardIcon key={index} cardType={card} active={isActive} />;
		});
	return (
		<StyledCardIconGroup>
			{/* <div className='copy'> Secure Payment</div> */}
			<div className='card-group'>{renderCardIcons()}</div>
		</StyledCardIconGroup>
	);
};

CreditCardIconGroup.defaultProps = {
	validCards: ['MasterCard', 'Visa', 'AmericanExpress'],
	activeCard: 'All',
};
CreditCardIconGroup.propTypes = {
	/**
	 * The value of the credit card to render
	 */
	activeCard: PropTypes.oneOf(['All', 'AmericanExpress', 'Visa', 'MasterCard']),
	/**
	 * An array of valid cards
	 */
	validCards: PropTypes.array,
};
export default CreditCardIconGroup;
